<template>
  <el-container class="container">
    <el-header class="header">
      <Header></Header>
    </el-header>
    <el-container class="mainContainer">
      <el-aside class="aside" style="width: auto">
        <LeftNav></LeftNav>
      </el-aside>
      <el-main class="main">
        <div class="main-div">
          <div>
            <div>
              <header-bread></header-bread>
            </div>
            <router-view></router-view>
          </div>
          <div style="margin-top: 20px">
            <footers></footers>
          </div>
        </div>
      </el-main>
    </el-container>

  </el-container>
</template>

<script>
import LeftNav from "@/components/LeftNav";
import Header from "@/components/Header";
import {copyText} from "@/utils/windowsUtils";
import HeaderBread from "@/components/HeaderBread";
import Footers from "@/components/Footers.vue";

export default {
  name: "Home",
  components: {Footers, HeaderBread, Header, LeftNav},
  mounted() {
    var userAgent = navigator.userAgent.toLowerCase();//判断是否在微信中打开
    if (userAgent.indexOf('micromessenger') !== -1) {
      this.$confirm(`用微信内置的浏览器打开网页可能会出现样式错位，影响操作效果。建议用其他浏览器打开。`, '提示', {
        confirmButtonText: `点击复制网页地址`,
        showCancelButton: false,
        closeOnClickModal: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        // 关键
        copyText(window.location.href)
      })
    }
  },
}
</script>

<style scoped>
.aside {
  overflow-x: hidden;
}

.el-main {
  height: calc(100vh - 60px);
}

.header {

  z-index: 99;
  padding: 0px;
  height: 65px !important;
  background: linear-gradient(to right, #eef7f8, rgb(253, 253, 254));
  box-shadow: 0px 1px 0px #d9ecee;
  border-bottom: 1px solid #d9ecee;
}

.el-main {
  height: calc(100vh - 65px);
}

.mainContainer {
  height: calc(100vh - 65px);
}
.main-div{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
